import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import IconRender from '../menu-vertical/icon-render'
import {
  StyledMenuSimple,
  StyledMenuContentNavItem,
  StyledMenuContent,
} from './styled/menu-simple'
import Tooltip from '../../tooltip'
import { getCurrentUrl } from '../utils'

const MenuSimple = (props) => {
  const {
    style,
    backgroundColor,
    textColor,
    hoverFontColor,
    className,
    menuData,
    selectedBackgroundColor,
    onMenuSelect,
    topComponent,
    bottomComponent,
  } = props

  const [_menuData, setMenuData] = useState(menuData)

  useEffect(() => {
    setMenuData(menuData)
  }, [menuData])

  const getIsHover = (nav, navIdx, index, hoverFlag) => {
    nav.isHover = index === navIdx ? hoverFlag : false
    return nav
  }
  const handleMouseEvent = (index, hoverFlag) => {
    let arr = []
    arr = (_menuData || []).map((nav, navIdx) =>
      getIsHover(nav, navIdx, index, hoverFlag)
    )
    setMenuData(arr)
  }

  // 处理点击某个nav的事件
  const handleClickEvent = (nav) => {
    console.log(nav)
    onMenuSelect(nav)
  }

  return (
    <StyledMenuSimple
      style={style}
      className={clsx(['bg-indigo-900', className])}
      backgroundColor={backgroundColor}
    >
      {/* 企业信息 */}
      {topComponent}

      <StyledMenuContent selectedBackgroundColor={selectedBackgroundColor}>
        {(_menuData || []).map((nav, index) => {
          return (
            <StyledMenuContentNavItem
              key={nav.url}
              onMouseOver={() => {
                handleMouseEvent(index, true)
              }}
              onMouseOut={() => {
                handleMouseEvent(index, false)
              }}
              onClick={() => {
                handleClickEvent(nav)
              }}
              className={clsx({
                'menu-simple-nav-item-active': getCurrentUrl().includes(
                  nav.matchUrl
                ),
              })}
            >
              <Tooltip
                position="right"
                on={['hover']}
                trigger={
                  <div className="menu-simple-nav-item-box before:bg-primary">
                    <IconRender
                      width="31px"
                      height="31px"
                      url={nav.icon}
                      className={
                        nav.isHover || getCurrentUrl().includes(nav.matchUrl)
                          ? 'text-light-900'
                          : 'text-secondary-50'
                      }
                      fill={
                        nav.isHover || getCurrentUrl().includes(nav.matchUrl)
                          ? hoverFontColor
                          : textColor
                      }
                    />
                  </div>
                }
              >
                <span dangerouslySetInnerHTML={{ __html: nav.name }} />
              </Tooltip>
            </StyledMenuContentNavItem>
          )
        })}
      </StyledMenuContent>

      {/* 用户信息 */}
      {bottomComponent}
    </StyledMenuSimple>
  )
}

// 默认参数
MenuSimple.defaultProps = {
  style: undefined,
  backgroundColor: undefined,
  textColor: undefined,
  hoverFontColor: undefined,
  className: undefined,
  menuData: undefined,
  selectedBackgroundColor: undefined,
  onMenuSelect: undefined,
  topComponent: undefined,
  bottomComponent: undefined,
}
// 参数类型
MenuSimple.propTypes = {
  style: PropTypes.shape({}),
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  hoverFontColor: PropTypes.string,
  className: PropTypes.string,
  menuData: PropTypes.arrayOf(PropTypes.object),
  onMenuSelect: PropTypes.func,
  topComponent: PropTypes.node,
  bottomComponent: PropTypes.node,
  selectedBackgroundColor: PropTypes.string,
}

export default MenuSimple
